import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input, TemplateRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import type { MenuItem } from "primeng/api";
import * as FlatModels from "@medsurf/flat-models";

@Component({
    selector: 'medsurf-design-content-panel',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './panel.content.design.html',
    styleUrls: ['./panel.content.design.scss'],
    standalone: false
})
export class PanelContentDesign {
	@Input({ required: true }) titleText!: string;
  @Input() tooltipLabel?: string;
	@Input() contentClass?: string;
	@Input() buttonClass: FlatModels.ButtonDesignModels.ButtonDesignClass = FlatModels.ButtonDesignModels.ButtonDesignClass.SECONDARY_SMALL_TEXT;
	@Input() menuClass: FlatModels.PanelDesignModels.MenuDesignClass = FlatModels.PanelDesignModels.MenuDesignClass.DEFAULT;
	@Input() toggleable = false;
	@Input() collapsed = false;
	@Input() menuItems?: MenuItem[];
	
	@ContentChild('header') header_template: TemplateRef<ElementRef> | null = null;
	
  addCollapseMenuItem = () => {
    if (!this.menuItems?.length) {
      return undefined;
    }
    return (this.menuItems).concat([
      {
        separator: true,
      },
      {
        label: this.translate.instant(this.collapsed ? 'global.panel_open': 'global.panel_close'),
        icon: this.getCollapsedClass(),
        command: () => this.toggleIsMinimized(),
      }
    ] satisfies MenuItem[]);
  }
  readonly FlatModels = FlatModels;

  constructor(private translate: TranslateService) {
  }
  
  toggleIsMinimized() {
    this.collapsed = !this.collapsed;
  }
  
  getCollapsedClass() {
    return this.collapsed ? FlatModels.ButtonDesignModels.ButtonDefaultIcons.PLUS : FlatModels.ButtonDesignModels.ButtonDefaultIcons.MINUS;
  }
  
  getCollapsedLabel() {
    return this.collapsed ? 'global.expand' : 'global.collapse';
  }
}
